import { Component } from '@angular/core';
import { LoginService } from './services/login/login.service';
import { ScaleStore } from './services/scale.store';
import { Router } from '@angular/router';
import { AuthStore } from './services/auth.store';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(private authStore: AuthStore, private scaleStore: ScaleStore, private loginService: LoginService, private route: Router) {
    this.scaleStore.clearData();
  }

  ngOnInit(): void {
    if(this.authStore.isLoggedLocal()) {
      console.log(this.route.url, 'url')
      const user = this.authStore.getUser();
      if(user.roles?.includes('USER_ADMIN')){
        this.loginService.carregarEmpresasAdmin(user.userId!);
      }
      else if(user.roles?.includes('GESTOR')){
        this.loginService.carregarEmpresasGestor(user.id!);
      }
    } else {
      this.scaleStore.clearData();
      this.authStore.logout();
    }
  }
}
